import { useSelector } from "react-redux";
import { formState } from "../features/AppSlice.js";
import * as React from "react";
import { Grid } from "@mui/material";

export default function TaxpayerInfoComponent() {
  const reduxFormState = useSelector(formState);

  return (
    <>
      <Grid
        container
        sx={{
          display: { xs: "block", sm: "block", md: "none", lg: "none" },
          position: "sticky",
          top: "0",
          zIndex: "800",
        }}
        fontFamily={"arial,helvetica"}
        fontSize={14}
        style={{
          backgroundColor: "rgb(0,56,101)",
          color: "white",
        }}
        padding={2}
      >
        <Grid container columnSpacing={1} wrap="nowrap">
          <Grid
            xs={6}
            container
            item
            justifyContent={"flex-start"}
            sx={{ marginLeft: "1%" }}
          >
            <b>Tax No:</b> {reduxFormState.values?.TaxNumber}
          </Grid>
          <Grid
            xs={6}
            container
            item
            justifyContent={"flex-end"}
            sx={{ marginRight: "1%" }}
          >
            <b>Tax Year:</b> {reduxFormState.values?.TaxYear}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: { xs: "none", sm: "none", md: "block", lg: "none" },
          position: "sticky",
          top: "0",
          zIndex: "800",
        }}
        fontFamily={"arial,helvetica"}
        fontSize={14}
        style={{
          backgroundColor: "rgb(0,56,101)",
          color: "white",
        }}
        padding={2}
      >
        <Grid container columnSpacing={1} wrap="nowrap">
          <Grid
            xs={6}
            container
            item
            justifyContent={"flex-start"}
            sx={{ marginLeft: "1%" }}
          >
            <b>Name:</b> {reduxFormState.values?.Name}{" "}
            {reduxFormState.values?.Surname}
          </Grid>
          <Grid xs={6} container item justifyContent={"center"}>
            <b>Tax No:</b> {reduxFormState.values?.TaxNumber}
          </Grid>
          <Grid
            xs={6}
            container
            item
            justifyContent={"flex-end"}
            sx={{ marginRight: "1%" }}
          >
            <b>Tax Year:</b> {reduxFormState.values?.TaxYear}
          </Grid>
        </Grid>
      </Grid>
      <Grid
        container
        sx={{
          display: { xs: "none", sm: "none", md: "none", lg: "block" },
          position: "sticky",
          top: "-16px",
          zIndex: "800",
        }}
        fontFamily={"arial,helvetica"}
        fontSize={14}
        style={{
          backgroundColor: "rgb(0,56,101)",
          color: "white",
        }}
        paddingTop={2}
        paddingBottom={2}
        paddingLeft={6}
        paddingRight={0}
      >
        <Grid container columnSpacing={1} wrap="nowrap">
          <Grid container item xs={2.4} justifyContent={"flex-start"}>
            <b>Name:</b> {reduxFormState.values?.Name}{" "}
            {reduxFormState.values?.Surname}
          </Grid>
          {reduxFormState.values?.IDType === "1" ? (
            <Grid container item xs={2.4} justifyContent={"center"}>
              <b>ID No:</b> {reduxFormState.values?.IDNumber}
            </Grid>
          ) : (
            <Grid container item xs={2.4} justifyContent={"center"}>
              <b>Passport:</b> {reduxFormState.values?.Passport}
            </Grid>
          )}
          <Grid container item xs={2.4} justifyContent={"center"}>
            <b>Tax No:</b> {reduxFormState.values?.TaxNumber}
          </Grid>
          <Grid container item xs={2.4} justifyContent={"center"}>
            <b>Tax Year:</b> {reduxFormState.values?.TaxYear}
          </Grid>
          <Grid container item xs={2.4} justifyContent={"flex-right"}>
            <b>Updated:</b> {new Date().toLocaleString() + ""}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
}
